module.exports = __webpack_public_path__ + "static/media/assign_task.e308577d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assign_task.svg
// module id = 154
// module chunks = 0